import Login from "@/pages/login";
import ResetPassword from "@/pages/redefinir-senha";
import ResetPasswordDetails from "@/pages/redefinir-senha/id";
import SejaPago from "@/pages/seja-pago";
import CustomLinks from "@/pages/links-customizados";
import CustomLinksEdit from "@/pages/links-customizados/id";
import Assinaturas from "@/pages/assinaturas";
import AssinaturaEdit from "@/pages/assinaturas/id";
import Clientes from "@/pages/clientes";

import Usuarios from "@/pages/usuarios";
import ClientesDetails from "@/pages/clientes/id";
import AdicionarCliente from "@/pages/clientes/adicionar-cliente";
import CobrancasHistorico from "@/pages/cobrancas-historico";
import CobrancaDetalhes from "@/pages/cobrancas-historico/id";
import CobrancaAgendadaDetalhes from "@/pages/cobrancas-agendadas/id";
import MyPlans from "@/pages/meu-checkout/meus-planos";
import MeuCheckoutInfo from "@/pages/meu-checkout/checkout-info";
import Notifications from "@/pages/configuracoes/notifications";
import PaymentMethods from "@/pages/configuracoes/metodos-pagamentos";
import NotaFiscal from "@/pages/configuracoes/nota-fiscal";
import Integracao from "@/pages/configuracoes/integracao";
import SubSellers from "@/pages/configuracoes/subsellers";
import NewDashboard from "@/pages/new-dashboard";
import Resgates from "@/pages/resgates";
import NewSubSeller from "./pages/configuracoes/subsellers/NewSubSeller";
import SubSeller from "./pages/configuracoes/subsellers/id";
import PjAccount from "./pages/configuracoes/ativar-conta-pj";
import AccountDetail from "./pages/configuracoes/dados-conta";
import Relatorios from "./pages/relatorios";
import DailyPixLimits from "./pages/configuracoes/limites-diarios";
import CreditCardPage from "@/pages/cartoes/cartao";
import ManageCreditCardPage from "@/pages/cartoes/gerenciar-cartoes";
import ManageCreditCardLimitsPage from "@/pages/cartoes/gerenciar-limites";
import ManageCreditCardInvoicesPage from "@/pages/cartoes/gerenciar-faturas";
import InvoicePage from "@/pages/cartoes/gerenciar-faturas/id";
import TreasuryPage from "@/pages/tesouraria";
import Segurity from "./pages/configuracoes/seguranca";
import ImpersonateCallback from "./pages/auth/ImpersonateCallback";
import Pagamentos from "./pages/pagamentos";
import PagamentosLote from "./pages/pagamentos-lote";
import { TreasuryProvider } from "./hooks";
import { ChargeFilterProvider } from "./hooks/useChargeFilter";
import { PaymentProvider } from "./hooks/usePayment";


let pathname = window.location.pathname;
const bankingAccountStatus = localStorage.getItem("barte-banking-account");

function generateKey(route: { path?: string; title?: string; breadcrumb?: string }) {
  if (route.path && route.path.trim() !== "") return `route-${route.path}`;
  if (route.title && route.title.trim() !== "") return `route-${route.title}`;
  if (route.breadcrumb && route.breadcrumb.trim() !== "") return `route-${route.breadcrumb}`;
  return crypto.randomUUID(); // fallback
}

export const RoutesList = [
  {
    path: "/",
    title: "Início",
    breadcrumb: "Início",
    icon: "home_outline.svg",
    isShowMenu: true,
    defaultIsOpen: false,
    isNew: false,
    exact: true,
    element: <NewDashboard />,
    feature: "view_seller_home",
    role: ["SELLER_MASTER", "SELLER_ADMIN", "SELLER_BACKOFFICE", "SELLER_DASHBOARD"],
    section: "HOME"
  },
  {
    title: "",
    breadcrumb: "",
    path: "/login",
    exact: true,
    element: <Login />,
    feature: "",
    role: [],
  },
  {
    title: "",
    breadcrumb: "",
    path: "/auth/impersonate",
    exact: true,
    element: <ImpersonateCallback />,
    feature: "",
    role: [],
  },
  {
    title: "",
    breadcrumb: "",
    path: "/redefinir-senha",
    exact: true,
    element: <ResetPassword />,
    feature: "",
    role: [],
  },
  {
    title: "",
    breadcrumb: "",
    path: "/redefinir-senha/:id",
    exact: true,
    element: <ResetPasswordDetails />,
    feature: "",
  },
  {
    title: "Criar",
    breadcrumb: "Criar",
    path: "/seja-pago/criar/:id",
    exact: true,
    element: <SejaPago />,
    icon: "plus.svg",
    feature: "view_seller_create_payment_link",
    role: ["SELLER_MASTER", "SELLER_ADMIN", "SELLER_BACKOFFICE", "SELLER_PAYMENT_LINK"],
  },
  {
    path: "/tesouraria",
    title: "Tesouraria",
    breadcrumb: "Tesouraria",
    icon: "chart.svg",
    isShowMenu: true,
    defaultIsOpen: false,
    isNew: false,
    exact: true,
    element: <TreasuryProvider><TreasuryPage /></TreasuryProvider>,
    role: ["SELLER_MASTER", "B_SELLER_ADMIN", "SELLER_BACKOFFICE", "BANKING_ADMIN", "BANKING_WALLET", "BANKING_VISUALIZATION", "BANKING_PAYMENT_REQUEST", "BANKING_INVESTMENT", "BANKING_TRANSFER", "BANKING_READ_ONLY"],
    section: "BANKING"
  },
  {
    path: "/seja-pago",
    title: "Links de pagamento",
    breadcrumb: "Links de pagamento",
    icon: "plus.svg",
    isShowMenu: true,
    defaultIsOpen: false,
    isNew: false,
    exact: true,
    element: <CustomLinks />,
    feature: "view_seller_payment_link",
    role: ["SELLER_MASTER", "SELLER_ADMIN", "SELLER_BACKOFFICE", "SELLER_PAYMENT_LINK"],
    section: "ACQUIRING"
  },
  {
    title: "Editar",
    breadcrumb: "Editar",
    path: "/seja-pago/editar/:id",
    exact: true,
    element: <CustomLinksEdit />,
    feature: "view_seller_payment_link_edit",
    role: ["SELLER_MASTER", "SELLER_ADMIN", "SELLER_BACKOFFICE", "SELLER_PAYMENT_LINK"],
  },
  {
    path: "/checkout-info",
    detail: "/meu-checkout",
    title: "Meu Checkout",
    breadcrumb: "Meu Checkout",
    icon: "shopping_cart.svg",
    isShowMenu: true,
    exact: true,
    element: <MeuCheckoutInfo />,
    feature: "view_seller_info_default",
    role: ["SELLER_MASTER", "SELLER_ADMIN", "SELLER_BACKOFFICE", "SELLER_CHECKOUT"],
    section: "ACQUIRING"
  },
  {
    path: "/meus-planos",
    title: "Meus Planos",
    breadcrumb: "Meus Planos",
    icon: "invoice.svg",
    isShowMenu: true,
    exact: true,
    element: <MyPlans />,
    feature: "view_seller_plans",
    role: ["SELLER_MASTER", "SELLER_ADMIN", "SELLER_BACKOFFICE", "SELLER_CHECKOUT"],
    section: "ACQUIRING"
  },
  {
    detail: "/recebiveis",
    path: "/cobrancas",
    title: "Cobranças",
    breadcrumb: "Cobranças",
    icon: "receive.svg",
    isShowMenu: true,
    defaultIsOpen:
      pathname.includes("/cobrancas-historico") ||
      pathname.includes("/cobrancas-agendadas"),
    isNew: false,
    element: <ChargeFilterProvider><CobrancasHistorico /></ChargeFilterProvider>,
    feature: "view_seller_charges",
    role: ["SELLER_MASTER", "SELLER_ADMIN", "SELLER_BACKOFFICE", "SELLER_CHARGES"],
    section: "ACQUIRING"
  },
  {
    title: "Detalhes",
    breadcrumb: "Detalhes",
    path: "/cobrancas/:id",
    exact: true,
    element: <CobrancaDetalhes />,
    feature: "view_seller_charges_history_details",
    role: ["SELLER_MASTER", "SELLER_ADMIN", "SELLER_BACKOFFICE", "SELLER_CHARGES"],
  },
  {
    title: "Detalhes",
    breadcrumb: "Detalhes",
    path: "/cobrancas-agendadas/:id",
    exact: true,
    element: <CobrancaAgendadaDetalhes />,
    feature: "view_seller_charges_late_details",
    role: ["SELLER_MASTER", "SELLER_ADMIN", "SELLER_BACKOFFICE", "SELLER_CHARGES"],
  },
  {
    path: "/cartao",
    title: "Cartões",
    breadcrumb: "Gerenciar cartões",
    icon: "credit-card.svg",
    isShowMenu: true,
    defaultIsOpen: false,
    isNew: false,
    exact: true,
    element: <ManageCreditCardPage />,
    feature: "view_seller_banking_cards",
    role: ["B_SELLER_ADMIN", "BANKING_ADMIN", "BANKING_VISUALIZATION", "BANKING_CARD", "BANKING_TRANSFER", "BANKING_READ_ONLY"],
    section: "BANKING"
  },
  {
    path: "/cartao/limites",
    title: "Gerenciar limites",
    breadcrumb: "Gerenciar limites",
    icon: "credit-card.svg",
    isShowMenu: false,
    defaultIsOpen: false,
    isNew: false,
    exact: true,
    element: <ManageCreditCardLimitsPage />,
    feature: "view_seller_banking_cards",
    role: ["B_SELLER_ADMIN", "BANKING_ADMIN", "BANKING_VISUALIZATION", "BANKING_CARD", "BANKING_TRANSFER", "BANKING_READ_ONLY"],
  },
  {
    path: "/cartao/faturas",
    title: "Faturas",
    breadcrumb: "Faturas",
    icon: "credit-card.svg",
    isShowMenu: false,
    defaultIsOpen: false,
    isNew: false,
    exact: true,
    element: <ManageCreditCardInvoicesPage />,
    feature: "view_seller_banking_cards",
    role: ["B_SELLER_ADMIN", "BANKING_ADMIN", "BANKING_CARD", "BANKING_TRANSFER", "BANKING_READ_ONLY"],
  },
  {
    path: "/cartao/faturas/:id",
    title: "Detalhes da Fatura",
    breadcrumb: "Detalhes",
    icon: "credit-card.svg",
    isShowMenu: false,
    defaultIsOpen: false,
    isNew: false,
    exact: true,
    element: <InvoicePage />,
    feature: "view_seller_banking_cards",
    role: ["B_SELLER_ADMIN", "BANKING_ADMIN", "BANKING_CARD", "BANKING_TRANSFER", "BANKING_READ_ONLY"],
  },
  {
    path: "/cartao/:id",
    title: "Cartão de crédito",
    breadcrumb: "Cartão de crédito",
    icon: "credit-card.svg",
    isShowMenu: false,
    defaultIsOpen: false,
    isNew: false,
    exact: true,
    element: <CreditCardPage />,
    feature: "view_seller_banking_cards",
    role: ["B_SELLER_ADMIN", "BANKING_ADMIN", "BANKING_VISUALIZATION", "BANKING_CARD", "BANKING_TRANSFER", "BANKING_READ_ONLY"],
  },
  {
    path: "",
    title: "Pagamentos",
    breadcrumb: "Pagamentos",
    icon: "receive-out.svg",
    isShowMenu: true,
    isNew: false,
    exact: true,
    role: ["B_SELLER_ADMIN", "BANKING_ADMIN", "BANKING_PAYMENT_REQUEST", "BANKING_TRANSFER", "BANKING_READ_ONLY"],
    section: "BANKING",
    defaultIsOpen: Boolean(pathname.includes("/pagamentos-unicos") || pathname.includes("/pagamentos-lotes")),
    items: [
      {
        path: "/pagamentos-unicos",
        title: "Pagamentos",
        breadcrumb: "Pagamentos",
        exact: true,
        isShowMenu: true,
        element: <PaymentProvider><Pagamentos /></PaymentProvider>,
        role: ["B_SELLER_ADMIN", "BANKING_ADMIN", "BANKING_PAYMENT_REQUEST", "BANKING_TRANSFER", "BANKING_READ_ONLY"],
        icon: "receive-out.svg",
      },
      {
        path: "/pagamentos-lotes",
        title: "Pagamentos em lote",
        breadcrumb: "Pagamentos em lote",
        exact: true,
        isShowMenu: true,
        element: <PaymentProvider><PagamentosLote /></PaymentProvider>,
        role: ["B_SELLER_ADMIN", "BANKING_ADMIN", "BANKING_PAYMENT_REQUEST", "BANKING_TRANSFER", "BANKING_READ_ONLY"],
        icon: "receive-out.svg",
      },
    ],
  },
  {
    path: "/recorrencias",
    title: "Recorrências",
    breadcrumb: "Recorrências",
    icon: "subscription.svg",
    isShowMenu: true,
    defaultIsOpen: false,
    isNew: false,
    exact: true,
    element: <Assinaturas />,
    feature: "view_seller_subscription",
    role: ["SELLER_MASTER", "SELLER_ADMIN", "SELLER_BACKOFFICE", "SELLER_SUBSCRIPTIONS"],
    section: "ACQUIRING"
  },
  {

    title: "Detalhes",
    breadcrumb: "Detalhes",
    path: "/recorrencias/:id",
    exact: true,
    element: <AssinaturaEdit />,
    feature: "view_seller_subscription_details",
    role: ["SELLER_MASTER", "SELLER_ADMIN", "SELLER_BACKOFFICE", "SELLER_SUBSCRIPTIONS"],
  },
  {
    path: "/clientes",
    title: "Clientes",
    breadcrumb: "Clientes",
    icon: "id.svg",
    isShowMenu: true,
    defaultIsOpen: false,
    isNew: false,
    exact: true,
    element: <Clientes />,
    feature: "view_seller_clients",
    role: ["SELLER_MASTER", "SELLER_ADMIN", "SELLER_BACKOFFICE", "SELLER_CLIENTS"],
    section: "ACQUIRING"
  },
  {
    title: "Adicionar cliente",
    breadcrumb: "Adicionar cliente",
    path: "/clientes/adicionar-cliente",
    exact: true,
    element: <AdicionarCliente />,
    feature: "view_seller_clients_add",
    role: ["SELLER_MASTER", "SELLER_ADMIN", "SELLER_BACKOFFICE", "SELLER_CLIENTS"],
  },
  {
    title: "Editar cliente",
    breadcrumb: "Editar cliente",
    path: "/clientes/:id",
    exact: true,
    element: <ClientesDetails />,
    feature: "view_seller_clients_edit",
    role: ["SELLER_MASTER", "SELLER_ADMIN", "SELLER_BACKOFFICE", "SELLER_CLIENTS"],
  },
  {
    path: "",
    detail: "/configuracoes",
    title: "Configurações",
    breadcrumb: "Configurações",
    icon: "settings.svg",
    isShowMenu: true,
    defaultIsOpen:
      pathname.includes("/notificacoes") ||
      pathname.includes("/metodos-pagamentos") ||
      pathname.includes("/nota-fiscal") ||
      pathname.includes("/integracao") ||
      pathname.includes("/sub-vendedores") ||
      pathname.includes("/seguranca"),
    isNew: false,
    feature: "view_seller_configurations",
    role: ["SELLER_MASTER", "SELLER_ADMIN", "SELLER_BACKOFFICE", "SELLER_CONFIG_PAYMENT_METHODS", "SELLER_CONFIG_NF", "SELLER_CONFIG_INTEGRATION", "SELLER_CONFIG_NOTIFICATION", "SELLER_CHARGES", "SELLER_CLIENTS", "BANKING_ADMIN", "BANKING_WALLET", "BANKING_TRANSFER", "BANKING_READ_ONLY", "SELLER_CONFIG_WEBHOOK", "SELLER_VIZUALIZATION"],
    items: [
      {
        path: "/ativar-pj",
        title: "Ativar Conta PJ",
        breadcrumb: "Ativar Conta PJ",
        exact: true,
        isShowMenu: true,
        element: <PjAccount />,
        role: ["SELLER_ADMIN", "SELLER_BACKOFFICE", "SELLER_CONFIG_NOTIFICATION"],
        icon: "settings.svg",
      },
      {
        path: "/dados-conta",
        title: "Dados da Conta",
        breadcrumb: "Dados da Conta",
        exact: true,
        isShowMenu: true,
        element: <AccountDetail />,
        role: ["B_SELLER_ADMIN", "SELLER_BACKOFFICE", "BANKING_ADMIN", "BANKING_WALLET", "BANKING_TRANSFER", "BANKING_READ_ONLY"],
        icon: "settings.svg",
      },
      // {
      //   path: "/limites",
      //   title: "Limites",
      //   breadcrumb: "Limites",
      //   exact: true,
      //   isShowMenu: true,
      //   element: <Pix />,
      //   feature: "view_banking_account",
      //   role: ["B_SELLER_ADMIN", "SELLER_BACKOFFICE", "BANKING_ADMIN", "BANKING_WALLET"],
      //   icon: "settings.svg"
      // },
      {
        path: "/limites-diarios",
        title: "Limites Diários",
        breadcrumb: "Limites Diários",
        exact: true,
        isShowMenu: true,
        element: <DailyPixLimits />,
        role: ["B_SELLER_ADMIN", "SELLER_BACKOFFICE", "BANKING_ADMIN", "BANKING_WALLET", "BANKING_TRANSFER", "BANKING_READ_ONLY"],
        icon: "settings.svg"
      },
      {
        path: "/notificacoes",
        title: "Notificações",
        breadcrumb: "Notificações",
        exact: true,
        isShowMenu: true,
        element: <Notifications />,
        feature: "view_seller_notifications",
        role: ["SELLER_ADMIN", "SELLER_BACKOFFICE", "SELLER_CONFIG_NOTIFICATION"],
        icon: "settings.svg",
      },
      {
        path: "/metodos-pagamentos",
        title: "Métodos de Pagamento",
        breadcrumb: "Métodos de Pagamento",
        exact: true,
        isShowMenu: true,
        element: <PaymentMethods />,
        feature: "view_seller_payment_method",
        role: ["SELLER_MASTER", "SELLER_ADMIN", "SELLER_BACKOFFICE", "SELLER_CONFIG_PAYMENT_METHODS"],
        icon: "settings.svg",
      },
      {
        path: "/seguranca",
        title: "Segurança",
        breadcrumb: "Segurança",
        exact: false,
        isShowMenu: true,
        element: <Segurity />,
        feature: "view_seller_configurations",
        role: ["SELLER_MASTER", "SELLER_ADMIN", "SELLER_BACKOFFICE", "SELLER_CONFIG_PAYMENT_METHODS", "SELLER_CLIENTS", "SELLER_CHARGES"],
        icon: "settings.svg",
      },
      {
        path: "/nota-fiscal",
        title: "Nota fiscal",
        breadcrumb: "Nota fiscal",
        exact: true,
        isShowMenu: true,
        element: <NotaFiscal />,
        feature: "view_seller_nf",
        role: ["SELLER_MASTER", "SELLER_ADMIN", "SELLER_BACKOFFICE", "SELLER_CONFIG_NF", "SELLER_VIZUALIZATION"],
        icon: "settings.svg",
      },
      {
        path: "/integracao",
        title: "Integração",
        breadcrumb: "Integração",
        exact: true,
        isShowMenu: true,
        element: <Integracao />,
        feature: "view_seller_integration",
        role: ["SELLER_MASTER", "SELLER_ADMIN", "SELLER_BACKOFFICE", "SELLER_CONFIG_INTEGRATION", "SELLER_CONFIG_WEBHOOK"],
        icon: "settings.svg",
      },
      {
        path: "/sub-vendedores",
        title: "Sub-vendedores",
        breadcrumb: "Sub-vendedores",
        exact: true,
        isShowMenu: true,
        element: <SubSellers />,
        feature: "view_seller_sub_seller",
        role: ["SELLER_MASTER", "SELLER_ADMIN", "SELLER_BACKOFFICE"],
        icon: "settings.svg"
      }
    ],
    section: "GENERAL"
  },
  {
    path: "/financeiro",
    title: "Financeiro",
    breadcrumb: "Financeiro",
    icon: "wallet.svg",
    isShowMenu: true,
    defaultIsOpen: false,
    isNew: false,
    exact: true,
    element: <Resgates />,
    feature: "view_seller_finance",
    role: ["SELLER_ADMIN", "SELLER_BACKOFFICE", "SELLER_FINANCES", "SELLER_BALANCE_VISUALIZATION"],
    section: "ACQUIRING"
  },
  {
    path: "/reports",
    title: "Relatórios",
    breadcrumb: "Relatórios",
    icon: "report.svg",
    isShowMenu: true,
    defaultIsOpen: false,
    isNew: false,
    exact: true,
    element: <Relatorios />,
    feature: "view_seller_reports",
    role: ["B_SELLER_ADMIN", "BANKING_ADMIN", "BANKING_REPORT", "SELLER_ADMIN", "SELLER_BACKOFFICE", "SELLER_REPORTS", "BANKING_TRANSFER", "BANKING_READ_ONLY"],
    section: "ACQUIRING"
  },
  {
    path: "/sub-vendedores/novo",
    title: "Novo sub-vendedor",
    breadcrumb: "Novo sub-vendedor",
    exact: true,
    element: <NewSubSeller />,
    icon: "settings.svg",
    feature: "view_seller_sub_seller",
    role: ["SELLER_MASTER", "SELLER_ADMIN", "SELLER_BACKOFFICE"],
  },
  {
    path: "/sub-vendedores/:id",
    title: "Detalhes",
    breadcrumb: "Detalhes",
    exact: true,
    element: <SubSeller />,
    icon: "settings.svg",
    feature: "view_seller_sub_seller",
    role: ["SELLER_MASTER", "SELLER_ADMIN", "SELLER_BACKOFFICE"],
  },
  {
    path: "/usuarios",
    title: "Usuários",
    breadcrumb: "Usuários",
    icon: "users.svg",
    isShowMenu: true,
    defaultIsOpen: false,
    isNew: false,
    exact: true,
    element: <Usuarios />,
    feature: "view_create_users",
    role: ["SELLER_ADMIN", "SELLER_BACKOFFICE"],
    section: "GENERAL"
  },
];

export function flatRoutesList() {
  let flatItems = RoutesList.filter((item) => item.items)
    .map((item) =>
      item.items?.map((subItem) => ({
        ...subItem,
        key: generateKey(subItem),
      }))
    )
    .flat();
  return [...RoutesList, ...flatItems];
}
